<div class="technology-section">
	<nextgen-tech></nextgen-tech>

	<it-matters></it-matters>

	<purposefully-designed></purposefully-designed>

	<polymorphic-dev></polymorphic-dev>

	<meet-techstack></meet-techstack>
</div>

<ready-set></ready-set>
